import { Injectable } from '@angular/core';

declare let liveChat: (value: string) => void;

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  hideChat(): void {
    this.setChatDisplay('hide_launcher');
  }

  showChat(): void {
    this.setChatDisplay('show');
  }

  private setChatDisplay(value: string): void {
    liveChat(value);
  }
}
